import PropTypes from "prop-types"
import React from "react"
import TextChartODD13GHGEmissionsAverageMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsAverageMolecule"
import TextChartODD13AverageEquipmentsPerFteMolecule from "views/molecules/canvases/charts/TextChartODD13AverageEquipmentsPerFteMolecule"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"
import ChartAssetsNetworkDispatcher from "views/organisms/canvases/charts/ITDomainAnalysis/dispatcher/ChartAssetsNetworkDispatcher"
import ChartAssetsHostingDispatcher from "views/organisms/canvases/charts/ITDomainAnalysis/dispatcher/ChartAssetsHostingDispatcher"
import ChartAssetsWorkplaceDispatcher from "views/organisms/canvases/charts/ITDomainAnalysis/dispatcher/ChartAssetsWorkplaceDispatcher"
import TextChartODD13DomainGHGEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13DomainGHGEmissionsMolecule"
import { round } from "services/units/round"
import { useAppContext } from "components/AppContext"
import ScoreChartErrorBoundary from "components/ErrorBoundary/ScoreChartErrorBoundary"

const TransversalITDomainAnalysisOrganism = ({ score }) => {
  const maturity = ((values) =>
    values.length ? values.reduce((a, b) => a + b, 0) / values.length : 0)(
    [
      score?.odd13_workplace_maturity,
      score?.odd13_datacenter_internal_maturity,
      score?.odd13_network_maturity,
    ].filter(Number.isFinite)
  )
  const { score: globalScore } = useAppContext()

  const chart1TrendBadge = globalScore?.trend_badges?.odd13_it_domain_co2
  const chart2AverageEquipmentsTrendBadge =
    globalScore?.trend_badges?.odd13_co2_average_equipments
  const chart5TrendBadge = globalScore?.trend_badges?.odd13_number_of_workplace_equipment_per_employee
  const maturityTrendBadge = globalScore?.trend_badges?.odd13_it_domain_maturity

  const chart2 = () => {
    if (+score?.odd13_co2_average_equipments !== 0) {
      return (
        <TextChartODD13GHGEmissionsAverageMolecule
          score={score}
          trendBadge={chart2AverageEquipmentsTrendBadge}
        />
      )
    }

    return <ScoreChartErrorBoundary />
  }

  return (
    <ScoreLayoutOrganism
      maturity={round(maturity, 0)}
      maturityTrendBadge={maturityTrendBadge}
      chart1={
        <TextChartODD13DomainGHGEmissionsMolecule
          score={score}
          ghgEmissions={score?.odd13_it_domain_co2}
          trendBadge={chart1TrendBadge}
        />
      }
      chart2={chart2()}
      chart3={
        score?.has_internal_datacenter_inventories ? (
          <ChartAssetsHostingDispatcher envScore={score} />
        ) : (
          <ScoreChartErrorBoundary />
        )
      }
      chart4={
        score?.has_workplace_equipment_inventories ? (
          <ChartAssetsWorkplaceDispatcher envScore={score} />
        ) : (
          <ScoreChartErrorBoundary />
        )
      }
      chart5={
        <TextChartODD13AverageEquipmentsPerFteMolecule 
          score={score} 
          trendBadge={chart5TrendBadge}
        />
      }
      chart6={
        score?.has_network_equipment_inventories ? (
          <ChartAssetsNetworkDispatcher envScore={score} />
        ) : (
          <ScoreChartErrorBoundary />
        )
      }
    />
  )
}

TransversalITDomainAnalysisOrganism.propTypes = {
  score: PropTypes.object.isRequired,
  trendBadges: PropTypes.object,
}

TransversalITDomainAnalysisOrganism.defaultProps = {
  trendBadges: {},
}

export default TransversalITDomainAnalysisOrganism